import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-left-nav',
    templateUrl: './left-nav.component.html',
    styleUrls: ['./left-nav.component.scss'],
    standalone: false
})
export class LeftNavComponent implements OnInit, AfterViewInit {
  @Input() public currentRoute:string;

  contactActive:string ="";
  organizationActive:string ="";
  servicesActive:string ="";
  clinicDetailsActive:string ="";
  coverageActive:string ="";
  reviewActive:string ="";

  constructor() { 
    
    
  }

  ngOnInit(): void {
    
  }
  ngAfterViewInit(): void {
    
  }
  getCSS(routeName: string, menuName: string){
    if(routeName.includes(menuName) || routeName == "/")
    {
       return "active";
    }
    else
    {
      return "";
    }
  }
}
